const fallbackFonts =  'Arial, Helvetica, sans-serif';

export const fontFamily = {
  vMCircularWhisperPTT: `VMCircularWhisperPTT, ${fallbackFonts}`,
  vMCircularChatPTT: `VMCircularChatPTT, ${fallbackFonts}`,
  vMCircularYellPTT: `VMCircularYellPTT, ${fallbackFonts}`,
  vMCircularNatterPTT: `VMCircularNatterPTT, ${fallbackFonts}`,
  vMCircularShoutPTT: `VMCircularShoutPTT, ${fallbackFonts}`,

  vmAeonikProLight: `VMAeonikProLight, ${fallbackFonts}`,
  vmAeonikProRegular: `VMAeonikProRegular, ${fallbackFonts}`,
  vmAeonikProMedium: `VMAeonikProMedium, ${fallbackFonts}`,
  vmAeonikProBold: `VMAeonikProBold, ${fallbackFonts}`,
  vmRobotoLight: `VMRobotoLight, ${fallbackFonts}`,
  vmAeonikProBlack: `VMAeonikProBlack, ${fallbackFonts}`,
  vmRobotoRegular: `VMRobotoRegular, ${fallbackFonts}`,
  vmRobotoMedium: `VMRobotoMedium, ${fallbackFonts}`
};

export const color = {
  vmRed: '#ed0000',
  plum: '#322332',
  purple: '#5f2878',
  shadowRed: '#bb0a00',
  shadowPlum: '#160f16',
  shadowPurple: '#3b164c',
  white: '#ffffff',
  grey80: '#333333',
  vmBlue: '#0019a5',
  vmBlueLight: '#191693',
  shadowBlue: '#000066',
  azure:'#070cac',
  navyBlue: '#000566',
  black: '#000000',
  metallicSeaweed: '#1b7782',
  green: '#348437',
  amber: '#e5931d',
  magenta: '#ff00ff',
  lime: '#bfff00'
};
